import includes from "lodash/includes";
import styled from "styled-components";
export default {
    RotatedArrow: styled.i
        .withConfig({
        shouldForwardProp: (prop) => !includes(["size", "rotate", "defaultRotate"], prop)
    })
        .attrs({
        className: "clickable"
    }) `
    font-size: ${({ size }) => size || 0}px !important;
    &:before,
    &:after {
      transform: rotate(${({ defaultRotate }) => defaultRotate}deg);
      transition: transform 0.4s linear;
      display: block;
    }

    &.open:before,
    &.open:after {
      transform: rotate(${({ rotate }) => rotate}deg);
    }

    &.animate-hover-color:before,
    &.animate-hover-color:after {
      transition:
        transform 0.4s linear,
        opacity 0.15s;
    }
  `
};
